import CircularLoader from "@/components/loading/LoadingComponent";
import { AuthContext } from "@/contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface GuardProps {
    children: React.ReactNode;
}

const AlreadyHasShieldGuard = ({ children }: GuardProps) => {
    console.debug("Executing AlreadyHasShieldGuard");

    const { user, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the user.player.shield exists, if it does then navigate to /dashboard
        // If user.player doesn't exist then navigate to /subscribe
        if (!loading && user) {
            if (!user.player) {
                navigate("/subscribe");
            } else if (user.player.shield) {
                navigate("/dashboard");
            }
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return <>{children}</>;
};

export default AlreadyHasShieldGuard;
